const dummyPosts = [
  {
    id: 1,
    user: { id: "self", name: "You", avatar: "https://via.placeholder.com/50" }, // Self Post
    content: "Excited to close a new real estate deal today! 🎉🏡",
    timestamp: "Just now",
    likes: 5,
  },
  {
    id: 2,
    user: { id: 101, name: "John Doe", avatar: "https://via.placeholder.com/50" },
    content: "Looking for a luxury apartment in NYC? I have some exclusive listings! DM me for details. 🏙️",
    timestamp: "10 minutes ago",
    likes: 12,
  },
  {
    id: 3,
    user: { id: 102, name: "Jane Smith", avatar: "https://via.placeholder.com/50" },
    content: "Just listed a beautiful waterfront home in Miami! 🌊🏡 #LuxuryHomes",
    timestamp: "30 minutes ago",
    likes: 20,
  },
  {
    id: 4,
    user: { id: "self", name: "You", avatar: "https://via.placeholder.com/50" }, // Self Post
    content: "Thinking about investing in real estate? Here are 3 things you need to know! 🏠💰",
    timestamp: "1 hour ago",
    likes: 8,
  },
  {
    id: 5,
    user: { id: 103, name: "Michael Johnson", avatar: "https://via.placeholder.com/50" },
    content: "Another successful closing today! Congrats to my amazing clients on their new home! 🎊🏡",
    timestamp: "2 hours ago",
    likes: 15,
  },
  {
    id: 6,
    user: { id: 104, name: "Emily Davis", avatar: "https://via.placeholder.com/50" },
    content: "Market trends are shifting! Here’s what to expect in Q4 2024. 📊📉",
    timestamp: "5 hours ago",
    likes: 25,
  },
  {
    id: 7,
    user: { id: 105, name: "Robert Brown", avatar: "https://via.placeholder.com/50" },
    content: "The best investment on Earth is Earth! 🌎💰 #RealEstate",
    timestamp: "Yesterday",
    likes: 30,
  },
  {
    id: 8,
    user: { id: "self", name: "You", avatar: "https://via.placeholder.com/50" }, // Self Post
    content: "Just finished a great client meeting. Excited for what's next! 🚀",
    timestamp: "Yesterday",
    likes: 4,
  },
];

export default dummyPosts;
